import { DeviceEutGroup } from "graphql/types"

export const getOperatingModes = (device: DeviceEutGroup): string[] => {
  return device.deviceDataGroup
    .flatMap((group) => group.deviceData)
    .filter((data) => data.isOperatingMode)
    .flatMap((data) => data.data || [])
    .filter((d) => d != null)
    .map((d) => d.value)
    .filter((value) => value != null && value !== "")
}
